// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__OQcaM","svg":"Map_svg__lDSJQ","moving":"Map_moving__-dzOm","land":"Map_land__GKmng","highlightedArea":"Map_highlightedArea__5QUc7"};